import { render, staticRenderFns } from "./masterturselect.vue?vue&type=template&id=267913c4"
import script from "./masterturselect.vue?vue&type=script&lang=js"
export * from "./masterturselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports